import React from "react";

export const SMContext = React.createContext();
